export default __webpack_public_path__ + "static/media/photo--sm--huda-1.0040095a.jpg";